import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5c34d370 = () => interopDefault(import('../../../app/pages/articles/index.vue' /* webpackChunkName: "pages/articles/index" */))
const _6931c37c = () => interopDefault(import('../../../app/pages/build-website.vue' /* webpackChunkName: "pages/build-website" */))
const _3033567c = () => interopDefault(import('../../../app/pages/cancellation-policy.vue' /* webpackChunkName: "pages/cancellation-policy" */))
const _51f4920a = () => interopDefault(import('../../../app/pages/career-coach.vue' /* webpackChunkName: "pages/career-coach" */))
const _19165bf0 = () => interopDefault(import('../../../app/pages/coaches.vue' /* webpackChunkName: "pages/coaches" */))
const _da568124 = () => interopDefault(import('../../../app/pages/code-of-conduct.vue' /* webpackChunkName: "pages/code-of-conduct" */))
const _1e058d71 = () => interopDefault(import('../../../app/pages/digital-marketing.vue' /* webpackChunkName: "pages/digital-marketing" */))
const _17046799 = () => interopDefault(import('../../../app/pages/embed.vue' /* webpackChunkName: "pages/embed" */))
const _b4f348da = () => interopDefault(import('../../../app/pages/facilitate-public-speaking.vue' /* webpackChunkName: "pages/facilitate-public-speaking" */))
const _43607154 = () => interopDefault(import('../../../app/pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _9c9b3520 = () => interopDefault(import('../../../app/pages/features/index.vue' /* webpackChunkName: "pages/features/index" */))
const _a40a9d98 = () => interopDefault(import('../../../app/pages/for-business.vue' /* webpackChunkName: "pages/for-business" */))
const _7b96ba76 = () => interopDefault(import('../../../app/pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _2188c91e = () => interopDefault(import('../../../app/pages/get-in-touch.vue' /* webpackChunkName: "pages/get-in-touch" */))
const _38dd03f3 = () => interopDefault(import('../../../app/pages/giftcards.vue' /* webpackChunkName: "pages/giftcards" */))
const _174ed73a = () => interopDefault(import('../../../app/pages/green-consciousness.vue' /* webpackChunkName: "pages/green-consciousness" */))
const _2d0a014c = () => interopDefault(import('../../../app/pages/health.vue' /* webpackChunkName: "pages/health" */))
const _92fb49d2 = () => interopDefault(import('../../../app/pages/home-living.vue' /* webpackChunkName: "pages/home-living" */))
const _cafec5ba = () => interopDefault(import('../../../app/pages/join-now.vue' /* webpackChunkName: "pages/join-now" */))
const _a6e7fa72 = () => interopDefault(import('../../../app/pages/kb.vue' /* webpackChunkName: "pages/kb" */))
const _02369db6 = () => interopDefault(import('../../../app/pages/learn-to-code.vue' /* webpackChunkName: "pages/learn-to-code" */))
const _dd479840 = () => interopDefault(import('../../../app/pages/mental-health.vue' /* webpackChunkName: "pages/mental-health" */))
const _266b7ad3 = () => interopDefault(import('../../../app/pages/my-kintell/index.vue' /* webpackChunkName: "pages/my-kintell/index" */))
const _7fadc81a = () => interopDefault(import('../../../app/pages/not-interested.vue' /* webpackChunkName: "pages/not-interested" */))
const _3ad5c4ac = () => interopDefault(import('../../../app/pages/personal-brand.vue' /* webpackChunkName: "pages/personal-brand" */))
const _0ba7ac86 = () => interopDefault(import('../../../app/pages/personal-finance.vue' /* webpackChunkName: "pages/personal-finance" */))
const _45aa7006 = () => interopDefault(import('../../../app/pages/pricing.vue' /* webpackChunkName: "pages/pricing" */))
const _426742c8 = () => interopDefault(import('../../../app/pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _3b3dec6e = () => interopDefault(import('../../../app/pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _66d642d0 = () => interopDefault(import('../../../app/pages/search.vue' /* webpackChunkName: "pages/search" */))
const _4dcc23f5 = () => interopDefault(import('../../../app/pages/sign-in.vue' /* webpackChunkName: "pages/sign-in" */))
const _8e6d39a4 = () => interopDefault(import('../../../app/pages/sign-out.vue' /* webpackChunkName: "pages/sign-out" */))
const _99624186 = () => interopDefault(import('../../../app/pages/startup.vue' /* webpackChunkName: "pages/startup" */))
const _f6fd2b38 = () => interopDefault(import('../../../app/pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _ee9a666a = () => interopDefault(import('../../../app/pages/videos/index.vue' /* webpackChunkName: "pages/videos/index" */))
const _2edb84bc = () => interopDefault(import('../../../app/pages/welcome.vue' /* webpackChunkName: "pages/welcome" */))
const _435bf780 = () => interopDefault(import('../../../app/pages/articles/the-future-of-co-living.vue' /* webpackChunkName: "pages/articles/the-future-of-co-living" */))
const _9d78e536 = () => interopDefault(import('../../../app/pages/f/cal.vue' /* webpackChunkName: "pages/f/cal" */))
const _9798b7d0 = () => interopDefault(import('../../../app/pages/f/k-cards.vue' /* webpackChunkName: "pages/f/k-cards" */))
const _61abc13f = () => interopDefault(import('../../../app/pages/f/pay.vue' /* webpackChunkName: "pages/f/pay" */))
const _42dc77ba = () => interopDefault(import('../../../app/pages/f/video-chat.vue' /* webpackChunkName: "pages/f/video-chat" */))
const _038dcebd = () => interopDefault(import('../../../app/pages/features/calendar-and-bookings.vue' /* webpackChunkName: "pages/features/calendar-and-bookings" */))
const _66e30596 = () => interopDefault(import('../../../app/pages/features/kintell-cards.vue' /* webpackChunkName: "pages/features/kintell-cards" */))
const _1cc7f5aa = () => interopDefault(import('../../../app/pages/features/payment-integration.vue' /* webpackChunkName: "pages/features/payment-integration" */))
const _210857fc = () => interopDefault(import('../../../app/pages/features/video-meetings.vue' /* webpackChunkName: "pages/features/video-meetings" */))
const _075bb78c = () => interopDefault(import('../../../app/pages/my-kintell/bookings/index.vue' /* webpackChunkName: "pages/my-kintell/bookings/index" */))
const _e887a1d6 = () => interopDefault(import('../../../app/pages/my-kintell/dashboard.vue' /* webpackChunkName: "pages/my-kintell/dashboard" */))
const _18fdf41b = () => interopDefault(import('../../../app/pages/my-kintell/kintell-cards/index.vue' /* webpackChunkName: "pages/my-kintell/kintell-cards/index" */))
const _64a33d67 = () => interopDefault(import('../../../app/pages/my-kintell/more/index.vue' /* webpackChunkName: "pages/my-kintell/more/index" */))
const _fa110cfa = () => interopDefault(import('../../../app/pages/my-kintell/my-calendar/index.vue' /* webpackChunkName: "pages/my-kintell/my-calendar/index" */))
const _027e24f3 = () => interopDefault(import('../../../app/pages/my-kintell/my-details/index.vue' /* webpackChunkName: "pages/my-kintell/my-details/index" */))
const _20e8b719 = () => interopDefault(import('../../../app/pages/my-kintell/my-groups/index.vue' /* webpackChunkName: "pages/my-kintell/my-groups/index" */))
const _adf5b82c = () => interopDefault(import('../../../app/pages/my-kintell/videos/index.vue' /* webpackChunkName: "pages/my-kintell/videos/index" */))
const _66099208 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/archive.vue' /* webpackChunkName: "pages/my-kintell/bookings/archive" */))
const _22a56299 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/confirmed.vue' /* webpackChunkName: "pages/my-kintell/bookings/confirmed" */))
const _efb5600c = () => interopDefault(import('../../../app/pages/my-kintell/bookings/requests.vue' /* webpackChunkName: "pages/my-kintell/bookings/requests" */))
const _2e74da03 = () => interopDefault(import('../../../app/pages/my-kintell/kintell-cards/create.vue' /* webpackChunkName: "pages/my-kintell/kintell-cards/create" */))
const _b2bc4c22 = () => interopDefault(import('../../../app/pages/my-kintell/more/credits.vue' /* webpackChunkName: "pages/my-kintell/more/credits" */))
const _7a30dda5 = () => interopDefault(import('../../../app/pages/my-kintell/more/favourites.vue' /* webpackChunkName: "pages/my-kintell/more/favourites" */))
const _fc9f9d74 = () => interopDefault(import('../../../app/pages/my-kintell/my-calendar/sync-settings.vue' /* webpackChunkName: "pages/my-kintell/my-calendar/sync-settings" */))
const _d467e6b8 = () => interopDefault(import('../../../app/pages/my-kintell/my-calendar/working-hours.vue' /* webpackChunkName: "pages/my-kintell/my-calendar/working-hours" */))
const _1e143fff = () => interopDefault(import('../../../app/pages/my-kintell/my-details/advisor-settings.vue' /* webpackChunkName: "pages/my-kintell/my-details/advisor-settings" */))
const _4fe9a3dc = () => interopDefault(import('../../../app/pages/my-kintell/my-details/billing.vue' /* webpackChunkName: "pages/my-kintell/my-details/billing" */))
const _b4cd77de = () => interopDefault(import('../../../app/pages/my-kintell/my-groups/facilitate-booking.vue' /* webpackChunkName: "pages/my-kintell/my-groups/facilitate-booking" */))
const _67fb27c0 = () => interopDefault(import('../../../app/pages/my-kintell/my-groups/members.vue' /* webpackChunkName: "pages/my-kintell/my-groups/members" */))
const _6e3fd49e = () => interopDefault(import('../../../app/pages/my-kintell/my-groups/members/_kintellGroup/index.vue' /* webpackChunkName: "pages/my-kintell/my-groups/members/_kintellGroup/index" */))
const _7a22d04a = () => interopDefault(import('../../../app/pages/my-kintell/my-groups/members/_kintellGroup/_member/index.vue' /* webpackChunkName: "pages/my-kintell/my-groups/members/_kintellGroup/_member/index" */))
const _939d0928 = () => interopDefault(import('../../../app/pages/my-kintell/my-groups/resources.vue' /* webpackChunkName: "pages/my-kintell/my-groups/resources" */))
const _795a86fd = () => interopDefault(import('../../../app/pages/my-kintell/my-groups/resources/_kintellGroup/index.vue' /* webpackChunkName: "pages/my-kintell/my-groups/resources/_kintellGroup/index" */))
const _26705e3d = () => interopDefault(import('../../../app/pages/my-kintell/bookings/initiate/already-agreed.vue' /* webpackChunkName: "pages/my-kintell/bookings/initiate/already-agreed" */))
const _70f946b5 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/initiate/book-favourite.vue' /* webpackChunkName: "pages/my-kintell/bookings/initiate/book-favourite" */))
const _379feb7e = () => interopDefault(import('../../../app/pages/my-kintell/bookings/initiate/book-someone.vue' /* webpackChunkName: "pages/my-kintell/bookings/initiate/book-someone" */))
const _ad36ccc4 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/initiate/invite-someone.vue' /* webpackChunkName: "pages/my-kintell/bookings/initiate/invite-someone" */))
const _3a2570ec = () => interopDefault(import('../../../app/pages/my-kintell/bookings/initiate/new-booking.vue' /* webpackChunkName: "pages/my-kintell/bookings/initiate/new-booking" */))
const _8d7bb5d2 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/initiate/repeat-booking.vue' /* webpackChunkName: "pages/my-kintell/bookings/initiate/repeat-booking" */))
const _7b502a42 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/initiate/schedule-for-later.vue' /* webpackChunkName: "pages/my-kintell/bookings/initiate/schedule-for-later" */))
const _2cb12cd4 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/initiate/you-suggest-time.vue' /* webpackChunkName: "pages/my-kintell/bookings/initiate/you-suggest-time" */))
const _018aab96 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/initiate/your-contact-suggests.vue' /* webpackChunkName: "pages/my-kintell/bookings/initiate/your-contact-suggests" */))
const _bb92b03e = () => interopDefault(import('../../../app/pages/articles/category/_category/index.vue' /* webpackChunkName: "pages/articles/category/_category/index" */))
const _73362c77 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/_id/index.vue' /* webpackChunkName: "pages/my-kintell/bookings/_id/index" */))
const _2bb4b087 = () => interopDefault(import('../../../app/pages/my-kintell/kintell-cards/_group.vue' /* webpackChunkName: "pages/my-kintell/kintell-cards/_group" */))
const _0f7639d5 = () => interopDefault(import('../../../app/pages/my-kintell/videos/_id/index.vue' /* webpackChunkName: "pages/my-kintell/videos/_id/index" */))
const _24073e24 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/_id/complete.vue' /* webpackChunkName: "pages/my-kintell/bookings/_id/complete" */))
const _fc7617b6 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/_id/confirm.vue' /* webpackChunkName: "pages/my-kintell/bookings/_id/confirm" */))
const _c31f0180 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/_id/end.vue' /* webpackChunkName: "pages/my-kintell/bookings/_id/end" */))
const _77d8eb15 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/_id/join.vue' /* webpackChunkName: "pages/my-kintell/bookings/_id/join" */))
const _38962220 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/_id/meeting.vue' /* webpackChunkName: "pages/my-kintell/bookings/_id/meeting" */))
const _3085b175 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/_id/reschedule.vue' /* webpackChunkName: "pages/my-kintell/bookings/_id/reschedule" */))
const _58a27583 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/_id/review.vue' /* webpackChunkName: "pages/my-kintell/bookings/_id/review" */))
const _5af58ce3 = () => interopDefault(import('../../../app/pages/my-kintell/bookings/_id/select-time.vue' /* webpackChunkName: "pages/my-kintell/bookings/_id/select-time" */))
const _982fde3c = () => interopDefault(import('../../../app/pages/my-kintell/bookings/_id/suggest-times.vue' /* webpackChunkName: "pages/my-kintell/bookings/_id/suggest-times" */))
const _3c244040 = () => interopDefault(import('../../../app/pages/advisors/_advisor/index.vue' /* webpackChunkName: "pages/advisors/_advisor/index" */))
const _2c6177cc = () => interopDefault(import('../../../app/pages/articles/_article/index.vue' /* webpackChunkName: "pages/articles/_article/index" */))
const _438d9638 = () => interopDefault(import('../../../app/pages/g/_kintellGroup/index.vue' /* webpackChunkName: "pages/g/_kintellGroup/index" */))
const _31d91b71 = () => interopDefault(import('../../../app/pages/v/_slug.vue' /* webpackChunkName: "pages/v/_slug" */))
const _10117a58 = () => interopDefault(import('../../../app/pages/g/_kintellGroup/apply.vue' /* webpackChunkName: "pages/g/_kintellGroup/apply" */))
const _2bfcc534 = () => interopDefault(import('../../../app/pages/g/_kintellGroup/join.vue' /* webpackChunkName: "pages/g/_kintellGroup/join" */))
const _b64c703c = () => interopDefault(import('../../../app/pages/g/_kintellGroup/videos.vue' /* webpackChunkName: "pages/g/_kintellGroup/videos" */))
const _f5aef570 = () => interopDefault(import('../../../app/pages/g/_kintellGroup/welcome.vue' /* webpackChunkName: "pages/g/_kintellGroup/welcome" */))
const _7fc03257 = () => interopDefault(import('../../../app/pages/advisors/_advisor/_kintellCard/index.vue' /* webpackChunkName: "pages/advisors/_advisor/_kintellCard/index" */))
const _5c100f74 = () => interopDefault(import('../../../app/pages/advisors/_advisor/_kintellCard/book.vue' /* webpackChunkName: "pages/advisors/_advisor/_kintellCard/book" */))
const _4410ca15 = () => interopDefault(import('../../../app/pages/advisors/_advisor/_kintellCard/edit.vue' /* webpackChunkName: "pages/advisors/_advisor/_kintellCard/edit" */))
const _5be6fcde = () => interopDefault(import('../../../app/pages/advisors/_advisor/_kintellCard/embed.vue' /* webpackChunkName: "pages/advisors/_advisor/_kintellCard/embed" */))
const _70aea114 = () => interopDefault(import('../../../app/pages/advisors/_advisor/_kintellCard/instant-meeting.vue' /* webpackChunkName: "pages/advisors/_advisor/_kintellCard/instant-meeting" */))
const _26bbad4c = () => interopDefault(import('../../../app/pages/advisors/_advisor/_kintellCard/respond.vue' /* webpackChunkName: "pages/advisors/_advisor/_kintellCard/respond" */))
const _078cfbf6 = () => interopDefault(import('../../../app/pages/advisors/_advisor/_kintellCard/sent-for-review.vue' /* webpackChunkName: "pages/advisors/_advisor/_kintellCard/sent-for-review" */))
const _3add9d12 = () => interopDefault(import('../../../app/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/articles",
    component: _5c34d370,
    name: "articles"
  }, {
    path: "/build-website",
    component: _6931c37c,
    name: "build-website"
  }, {
    path: "/cancellation-policy",
    component: _3033567c,
    name: "cancellation-policy"
  }, {
    path: "/career-coach",
    component: _51f4920a,
    name: "career-coach"
  }, {
    path: "/coaches",
    component: _19165bf0,
    name: "coaches"
  }, {
    path: "/code-of-conduct",
    component: _da568124,
    name: "code-of-conduct"
  }, {
    path: "/digital-marketing",
    component: _1e058d71,
    name: "digital-marketing"
  }, {
    path: "/embed",
    component: _17046799,
    name: "embed"
  }, {
    path: "/facilitate-public-speaking",
    component: _b4f348da,
    name: "facilitate-public-speaking"
  }, {
    path: "/faq",
    component: _43607154,
    name: "faq"
  }, {
    path: "/features",
    component: _9c9b3520,
    name: "features"
  }, {
    path: "/for-business",
    component: _a40a9d98,
    name: "for-business"
  }, {
    path: "/forgot-password",
    component: _7b96ba76,
    name: "forgot-password"
  }, {
    path: "/get-in-touch",
    component: _2188c91e,
    name: "get-in-touch"
  }, {
    path: "/giftcards",
    component: _38dd03f3,
    name: "giftcards"
  }, {
    path: "/green-consciousness",
    component: _174ed73a,
    name: "green-consciousness"
  }, {
    path: "/health",
    component: _2d0a014c,
    name: "health"
  }, {
    path: "/home-living",
    component: _92fb49d2,
    name: "home-living"
  }, {
    path: "/join-now",
    component: _cafec5ba,
    name: "join-now"
  }, {
    path: "/kb",
    component: _a6e7fa72,
    name: "kb"
  }, {
    path: "/learn-to-code",
    component: _02369db6,
    name: "learn-to-code"
  }, {
    path: "/mental-health",
    component: _dd479840,
    name: "mental-health"
  }, {
    path: "/my-kintell",
    component: _266b7ad3,
    name: "my-kintell"
  }, {
    path: "/not-interested",
    component: _7fadc81a,
    name: "not-interested"
  }, {
    path: "/personal-brand",
    component: _3ad5c4ac,
    name: "personal-brand"
  }, {
    path: "/personal-finance",
    component: _0ba7ac86,
    name: "personal-finance"
  }, {
    path: "/pricing",
    component: _45aa7006,
    name: "pricing"
  }, {
    path: "/privacy",
    component: _426742c8,
    name: "privacy"
  }, {
    path: "/reset-password",
    component: _3b3dec6e,
    name: "reset-password"
  }, {
    path: "/search",
    component: _66d642d0,
    name: "search"
  }, {
    path: "/sign-in",
    component: _4dcc23f5,
    name: "sign-in"
  }, {
    path: "/sign-out",
    component: _8e6d39a4,
    name: "sign-out"
  }, {
    path: "/startup",
    component: _99624186,
    name: "startup"
  }, {
    path: "/terms-and-conditions",
    component: _f6fd2b38,
    name: "terms-and-conditions"
  }, {
    path: "/videos",
    component: _ee9a666a,
    name: "videos"
  }, {
    path: "/welcome",
    component: _2edb84bc,
    name: "welcome"
  }, {
    path: "/articles/the-future-of-co-living",
    component: _435bf780,
    name: "articles-the-future-of-co-living"
  }, {
    path: "/f/cal",
    component: _9d78e536,
    name: "f-cal"
  }, {
    path: "/f/k-cards",
    component: _9798b7d0,
    name: "f-k-cards"
  }, {
    path: "/f/pay",
    component: _61abc13f,
    name: "f-pay"
  }, {
    path: "/f/video-chat",
    component: _42dc77ba,
    name: "f-video-chat"
  }, {
    path: "/features/calendar-and-bookings",
    component: _038dcebd,
    name: "features-calendar-and-bookings"
  }, {
    path: "/features/kintell-cards",
    component: _66e30596,
    name: "features-kintell-cards"
  }, {
    path: "/features/payment-integration",
    component: _1cc7f5aa,
    name: "features-payment-integration"
  }, {
    path: "/features/video-meetings",
    component: _210857fc,
    name: "features-video-meetings"
  }, {
    path: "/my-kintell/bookings",
    component: _075bb78c,
    name: "my-kintell-bookings"
  }, {
    path: "/my-kintell/dashboard",
    component: _e887a1d6,
    name: "my-kintell-dashboard"
  }, {
    path: "/my-kintell/kintell-cards",
    component: _18fdf41b,
    name: "my-kintell-kintell-cards"
  }, {
    path: "/my-kintell/more",
    component: _64a33d67,
    name: "my-kintell-more"
  }, {
    path: "/my-kintell/my-calendar",
    component: _fa110cfa,
    name: "my-kintell-my-calendar"
  }, {
    path: "/my-kintell/my-details",
    component: _027e24f3,
    name: "my-kintell-my-details"
  }, {
    path: "/my-kintell/my-groups",
    component: _20e8b719,
    name: "my-kintell-my-groups"
  }, {
    path: "/my-kintell/videos",
    component: _adf5b82c,
    name: "my-kintell-videos"
  }, {
    path: "/my-kintell/bookings/archive",
    component: _66099208,
    name: "my-kintell-bookings-archive"
  }, {
    path: "/my-kintell/bookings/confirmed",
    component: _22a56299,
    name: "my-kintell-bookings-confirmed"
  }, {
    path: "/my-kintell/bookings/requests",
    component: _efb5600c,
    name: "my-kintell-bookings-requests"
  }, {
    path: "/my-kintell/kintell-cards/create",
    component: _2e74da03,
    name: "my-kintell-kintell-cards-create"
  }, {
    path: "/my-kintell/more/credits",
    component: _b2bc4c22,
    name: "my-kintell-more-credits"
  }, {
    path: "/my-kintell/more/favourites",
    component: _7a30dda5,
    name: "my-kintell-more-favourites"
  }, {
    path: "/my-kintell/my-calendar/sync-settings",
    component: _fc9f9d74,
    name: "my-kintell-my-calendar-sync-settings"
  }, {
    path: "/my-kintell/my-calendar/working-hours",
    component: _d467e6b8,
    name: "my-kintell-my-calendar-working-hours"
  }, {
    path: "/my-kintell/my-details/advisor-settings",
    component: _1e143fff,
    name: "my-kintell-my-details-advisor-settings"
  }, {
    path: "/my-kintell/my-details/billing",
    component: _4fe9a3dc,
    name: "my-kintell-my-details-billing"
  }, {
    path: "/my-kintell/my-groups/facilitate-booking",
    component: _b4cd77de,
    name: "my-kintell-my-groups-facilitate-booking"
  }, {
    path: "/my-kintell/my-groups/members",
    component: _67fb27c0,
    name: "my-kintell-my-groups-members",
    children: [{
      path: ":kintellGroup",
      component: _6e3fd49e,
      name: "my-kintell-my-groups-members-kintellGroup"
    }, {
      path: ":kintellGroup?/:member",
      component: _7a22d04a,
      name: "my-kintell-my-groups-members-kintellGroup-member"
    }]
  }, {
    path: "/my-kintell/my-groups/resources",
    component: _939d0928,
    name: "my-kintell-my-groups-resources",
    children: [{
      path: ":kintellGroup",
      component: _795a86fd,
      name: "my-kintell-my-groups-resources-kintellGroup"
    }]
  }, {
    path: "/my-kintell/bookings/initiate/already-agreed",
    component: _26705e3d,
    name: "my-kintell-bookings-initiate-already-agreed"
  }, {
    path: "/my-kintell/bookings/initiate/book-favourite",
    component: _70f946b5,
    name: "my-kintell-bookings-initiate-book-favourite"
  }, {
    path: "/my-kintell/bookings/initiate/book-someone",
    component: _379feb7e,
    name: "my-kintell-bookings-initiate-book-someone"
  }, {
    path: "/my-kintell/bookings/initiate/invite-someone",
    component: _ad36ccc4,
    name: "my-kintell-bookings-initiate-invite-someone"
  }, {
    path: "/my-kintell/bookings/initiate/new-booking",
    component: _3a2570ec,
    name: "my-kintell-bookings-initiate-new-booking"
  }, {
    path: "/my-kintell/bookings/initiate/repeat-booking",
    component: _8d7bb5d2,
    name: "my-kintell-bookings-initiate-repeat-booking"
  }, {
    path: "/my-kintell/bookings/initiate/schedule-for-later",
    component: _7b502a42,
    name: "my-kintell-bookings-initiate-schedule-for-later"
  }, {
    path: "/my-kintell/bookings/initiate/you-suggest-time",
    component: _2cb12cd4,
    name: "my-kintell-bookings-initiate-you-suggest-time"
  }, {
    path: "/my-kintell/bookings/initiate/your-contact-suggests",
    component: _018aab96,
    name: "my-kintell-bookings-initiate-your-contact-suggests"
  }, {
    path: "/articles/category/:category",
    component: _bb92b03e,
    name: "articles-category-category"
  }, {
    path: "/my-kintell/bookings/:id",
    component: _73362c77,
    name: "my-kintell-bookings-id"
  }, {
    path: "/my-kintell/kintell-cards/:group",
    component: _2bb4b087,
    name: "my-kintell-kintell-cards-group"
  }, {
    path: "/my-kintell/videos/:id",
    component: _0f7639d5,
    name: "my-kintell-videos-id"
  }, {
    path: "/my-kintell/bookings/:id/complete",
    component: _24073e24,
    name: "my-kintell-bookings-id-complete"
  }, {
    path: "/my-kintell/bookings/:id/confirm",
    component: _fc7617b6,
    name: "my-kintell-bookings-id-confirm"
  }, {
    path: "/my-kintell/bookings/:id/end",
    component: _c31f0180,
    name: "my-kintell-bookings-id-end"
  }, {
    path: "/my-kintell/bookings/:id/join",
    component: _77d8eb15,
    name: "my-kintell-bookings-id-join"
  }, {
    path: "/my-kintell/bookings/:id/meeting",
    component: _38962220,
    name: "my-kintell-bookings-id-meeting"
  }, {
    path: "/my-kintell/bookings/:id/reschedule",
    component: _3085b175,
    name: "my-kintell-bookings-id-reschedule"
  }, {
    path: "/my-kintell/bookings/:id/review",
    component: _58a27583,
    name: "my-kintell-bookings-id-review"
  }, {
    path: "/my-kintell/bookings/:id/select-time",
    component: _5af58ce3,
    name: "my-kintell-bookings-id-select-time"
  }, {
    path: "/my-kintell/bookings/:id/suggest-times",
    component: _982fde3c,
    name: "my-kintell-bookings-id-suggest-times"
  }, {
    path: "/advisors/:advisor",
    component: _3c244040,
    name: "advisors-advisor"
  }, {
    path: "/articles/:article",
    component: _2c6177cc,
    name: "articles-article"
  }, {
    path: "/g/:kintellGroup",
    component: _438d9638,
    name: "g-kintellGroup"
  }, {
    path: "/v/:slug?",
    component: _31d91b71,
    name: "v-slug"
  }, {
    path: "/g/:kintellGroup?/apply",
    component: _10117a58,
    name: "g-kintellGroup-apply"
  }, {
    path: "/g/:kintellGroup?/join",
    component: _2bfcc534,
    name: "g-kintellGroup-join"
  }, {
    path: "/g/:kintellGroup?/videos",
    component: _b64c703c,
    name: "g-kintellGroup-videos"
  }, {
    path: "/g/:kintellGroup?/welcome",
    component: _f5aef570,
    name: "g-kintellGroup-welcome"
  }, {
    path: "/advisors/:advisor?/:kintellCard",
    component: _7fc03257,
    name: "advisors-advisor-kintellCard"
  }, {
    path: "/advisors/:advisor?/:kintellCard/book",
    component: _5c100f74,
    name: "advisors-advisor-kintellCard-book"
  }, {
    path: "/advisors/:advisor?/:kintellCard/edit",
    component: _4410ca15,
    name: "advisors-advisor-kintellCard-edit"
  }, {
    path: "/advisors/:advisor?/:kintellCard/embed",
    component: _5be6fcde,
    name: "advisors-advisor-kintellCard-embed"
  }, {
    path: "/advisors/:advisor?/:kintellCard/instant-meeting",
    component: _70aea114,
    name: "advisors-advisor-kintellCard-instant-meeting"
  }, {
    path: "/advisors/:advisor?/:kintellCard/respond",
    component: _26bbad4c,
    name: "advisors-advisor-kintellCard-respond"
  }, {
    path: "/advisors/:advisor?/:kintellCard/sent-for-review",
    component: _078cfbf6,
    name: "advisors-advisor-kintellCard-sent-for-review"
  }, {
    path: "/",
    component: _3add9d12,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
